import { create} from 'zustand';
import { persist } from 'zustand/middleware';

export interface IUserCancerDetectClicked {
  isCancerDetectClicked: boolean;
  setIsCancerDetectClicked: (value: boolean) => void;
}

export const useCancerDetectUser = create<IUserCancerDetectClicked>()(
  persist(
    (set) => ({
      isCancerDetectClicked: false,
      setIsCancerDetectClicked: (value) => set({ isCancerDetectClicked: value }),
    }),
    { name: 'cancer-detect' }
  ),
);